import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the TagsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'comp-tags',
  templateUrl: 'tags.html',
})
export class TagsPage {

  @Input() tags;

  constructor(public navCtrl: NavController,
    public navParams: NavParams) {
  }


}



// WEBPACK FOOTER //
// ./src/pages/components/tags/tags.ts